import { render, staticRenderFns } from "./LandfillPlanForm.vue?vue&type=template&id=8c4be2f8&scoped=true"
import script from "./LandfillPlanForm.vue?vue&type=script&lang=js"
export * from "./LandfillPlanForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4be2f8",
  null
  
)

export default component.exports